module.exports = __webpack_public_path__ + "assets/img/discount-active.ab717fc7.png";